import { render, staticRenderFns } from "./DocumentsListOurCompany.vue?vue&type=template&id=4f870dbd&scoped=true&"
import script from "./DocumentsListOurCompany.vue?vue&type=script&lang=js&"
export * from "./DocumentsListOurCompany.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsListOurCompany.vue?vue&type=style&index=0&id=4f870dbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f870dbd",
  null
  
)

export default component.exports